import { useRouter } from '@/routing/useAppRouter';

import APPS_HEADER_OPTION_DATA from '@/data/apps/header_options.json';

type AppsHeaderOptionType = {
  [pathName: string]: {
    isHeaderChanges: boolean;
  };
};

const DEFAULT_HEADER_OPTION = {
  isHeaderChanges: false,
};

export default function useAppsHeaderOptionData() {
  const router = useRouter();
  const appsHeaderOptions: AppsHeaderOptionType = APPS_HEADER_OPTION_DATA;

  return appsHeaderOptions[router.pathname] ?? DEFAULT_HEADER_OPTION;
}
